var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sellerinfo"},[_c('FormList',{attrs:{"list":_vm.formList,"data":_vm.formData,"onChange":_vm.onInputChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }